import React from "react";
import GrowthGraphsComponent from "./components/GrowthGraphsComponent";
import "./index.css";

const App: React.FC = () => {
  return (
    <div className="App">
      <GrowthGraphsComponent />
    </div>
  );
};

export default App;
